import { formatDate } from '@angular/common';
import { Component, Input } from '@angular/core';
import { interval } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { getTime, subHours, format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

@Component({
  selector: 'app-count-down',
  templateUrl: './count-down.component.html',
  styleUrls: [ './count-down.component.scss' ]
})
export class CountDownComponent {
  ASAP: boolean;
  hours: any;
  minutes: any;
  dataTimeTomorrow: any;
  afterEightPm: boolean;
  afterEightAm: boolean;
  showNothing: boolean;
  dateCreatedSource: any;
  seconds: string;

  @Input()
  set dateCreated(value: any) {
    this.dataTimeTomorrow = new Date().setDate(new Date().getDate() + 1);

    const timeZone = 'America/Indiana/Indianapolis';
    const now = new Date();
    const nowZoned = toZonedTime(now, timeZone);
    const transactionDateZoned = toZonedTime(new Date(value), timeZone);

    const timeSlots = [
      { hour: 8, minute: 0 },
      { hour: 10, minute: 30 },
      { hour: 13, minute: 0 },
      { hour: 15, minute: 30 },
      { hour: 18, minute: 0 },
      { hour: 20, minute: 0 },
      { hour: 23, minute: 59 },
    ];

    let diff = 0;
    let isPast = false;

    for (const slot of timeSlots) {
      const testTime = new Date(transactionDateZoned);
      testTime.setHours(slot.hour, slot.minute, 0, 0);

      const testUtc = getTime(testTime);
      const nowUtc = getTime(nowZoned);
      const transactionUtc = getTime(transactionDateZoned);
      const result = (testUtc - transactionUtc) / 1000;

      if (result > 0) {
        diff = (testUtc - nowUtc) / 1000;
        isPast = nowUtc > testUtc;
        break;
      }
    }

    if (isPast) {
      this.afterEightAm = false;
      this.afterEightPm = false;
      this.ASAP = true;
    }

    const diffFinal = Math.floor(diff);
    const [hours, minutes, seconds] = this.timeConvert(diffFinal);
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;

    this.dateCreatedSource = new Date(value);

    interval(1000)
      .pipe(
        take(diffFinal),
        finalize(() => (this.ASAP = true))
      )
      .subscribe(secondsElapsed => {
        const [h, m, s] = this.timeConvert(diffFinal - secondsElapsed);
        this.hours = h;
        this.minutes = m;
        this.seconds = s;
      });
  }

  timeConvert(n) {
    const convertor = format(new Date(n * 1000), 'HH:mm:ss');
    return convertor.split(':');
  }

  navigate() {
    window.open(
      'https://help.grassrootslabs.com/article/168-how-long-until-my-order-is-approved',
      '_blank'
    );
  }
}
